import { useContext } from 'react';
import { SettingsContext } from '../contexts/SettingsContext';

export default () => useContext(SettingsContext);
